export class AwsEc2InstanceRestoreTarget {
    'region';
    'instanceType';
    'subnetId';
    'securityGroupIds';
    'tags';
    'volumeRestoreParameters';
    'startInstanceAfterRestore';
    'instanceProfileName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceType",
            "baseName": "instanceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeRestoreParameters",
            "baseName": "volumeRestoreParameters",
            "type": "Array<RestoreInstanceVolumeInput>",
            "format": ""
        },
        {
            "name": "startInstanceAfterRestore",
            "baseName": "startInstanceAfterRestore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "instanceProfileName",
            "baseName": "instanceProfileName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2InstanceRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
